export default {
	state: () => ({
		returnButtonText: '',
	}),
	getters: {
		getReturnButtonText: state => {
			return state.returnButtonText;
		},
	},
	mutations: {
		setReturnButtonText: (state, textValue) => {
			state.returnButtonText = textValue;
		},
	},
};
